import { AppLayout } from "@amzn/awsui-components-console";
import React from "react";

import LoadingSpinner from "@/components/LoadingSpinner";

const LoadingPage: React.FC = () => (
  <AppLayout
    navigationHide
    toolsHide
    contentType="default"
    content={<LoadingSpinner />}
  />
);

export default LoadingPage;
